if (!customElements.get('nv-image-grid-slider')) {
  customElements.define(
    'nv-image-grid-slider',
    class ImageGridSlider extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        this.swiper = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: this.dataset.mobile || 1,
          loop: false,
          spaceBetween: parseInt(this.dataset.space) || 0,
          centeredSlides: false,
          breakpoints: {
            768: {
              slidesPerView: this.dataset.tablet || 2
            },
            1024: {
              slidesPerView: this.dataset.desktop || 3
            }
          }
        });
      }
    }
  );
}